<div class="container">
    <div class="row clearfix">
        <div class="col-md-12 column">
   <div style="text-align: center;"> <h2>信息系统用户注册确认</h2> </div>
<form [formGroup]="registerForm" (ngSubmit)="onSubmit()" style="margin-top: 40px;">
    <div class="form-group">
        <label for="emailConfirmCode">邮箱确认码</label>
        <input type="text" formControlName="emailConfirmCode" id="emailConfirmCode" name="emailConfirmCode" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.emailConfirmCode.errors }" />
        <div *ngIf="submitted && f.emailConfirmCode.errors" class="invalid-feedback">
            <div *ngIf="f.emailConfirmCode.errors.required">请输入邮箱确认码</div>
        </div>
    </div>   

    <div class="form-group">
        <button [disabled]="loading" class="btn btn-primary">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            提交
        </button>
    </div>
</form>
</div>
</div>
</div>